module.exports = __webpack_public_path__ + "static/media/Apple iPhone XS Silver.602f6cf2.png";